namespace $.$$ {
	
	$mol_style_define( $giper_baza_auth_slot, {
		
		flex: {
			basis: '25rem',
		},
		
		Key: {
			font: {
				family: 'monospace',
			},
		},
		
	} )
	
}
